import { Text } from '@creditinfo-ui/atoms'

import StepsIndicator from './StepsIndicator'
import CompanySelect from '../CompanySelect'

interface Props {
  tabs: string[]
  codesUploaded: boolean
  codesAccepted: number
  setCodesUploaded: Function
  setCodesAccepted: Function
}

export default function StepSelectCompanies ({ tabs, codesUploaded, codesAccepted, setCodesUploaded, setCodesAccepted }: Props): JSX.Element {
  return (
    <div className="container my-14 mx-auto xl:px-64 place-self-start">
      <div className="mb-8 md:mb-14">
        <Text
          message={{ id: 'selectCompanies.upload.title' }}
          variant="viewTitle"
        />
      </div>

      <StepsIndicator
        activeStep={0}
        steps={tabs}
      />

      <CompanySelect
        codesAccepted={codesAccepted}
        codesUploaded={codesUploaded}
        setCodesAccepted={function (count: number) { setCodesAccepted(count) }}
        setCodesUploaded={function (value: boolean) { setCodesUploaded(value) }}
      />
    </div>
  )
}
